import * as React from 'react'
import { SelectSeeker } from 'ui-seeker/core'

const OPTIONS = [
    {label: 'Last month', value: 'lastMonth'},
    {label: 'Last 3 months', value: 'last3Month'},
    {label: 'Last 6 months', value: 'last6Month'},
    {label: 'Last year', value: 'lastYear'},
    {label: 'Custom Date', value: 'custom'}
]

const PREV_OPTIONS = [
    {label: 'Previous Period', value: 'previous'},
    {label: 'Custom Date', value: 'custom'}
]

export default function SelectPrevRange({previous=false, ...props}) {

    const myProps = {
        label: 'Last Period',
        options: !previous ? OPTIONS : PREV_OPTIONS,
        isClearable: false, firstSelect: false, isMulti: false,
        icon: {icon: 'calendar'},
        ...props
    }

    return <SelectSeeker {...myProps} />
}